import { memo } from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';

function FundingTotalFeesForm({ fundingFeesSum }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Advance Total Fees:</Form.Label>
      </Col>
      <Col md={1} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="reason"
          id="reason"
          value={fundingFeesSum || ''}
          readOnly
        />
      </Col>
      <Col md={3} className="bo-same-line" />
    </>
  );
}

export default memo(FundingTotalFeesForm);
